import React, { useEffect, useRef, useState } from 'react';
import './App.css';
import AgoraRTC from "agora-rtc-sdk-ng";
import { changeAudio, changeVideo, setPortraitMode } from "../../components/streamControls/controls.actions";
import useAppDispatch from '../../../../hooks/useAppDispatch';
import useAppAccessor from '../../../../hooks/useappAccessor';

const MediaDeviceTest = () => {
  const dispatch = useAppDispatch();
  const [audioLevel, setAudioLevel] = useState(0);
  const videoRef = useRef<any>(null);
  const audioContextRef = useRef<any>(null);
  const analyserRef = useRef<any>(null);
  const microphoneRef = useRef<any>(null);
  const [cameraDevices, setCameraDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedCamera, setSelectedCamera] = useState<string>('');
  const { getControls } = useAppAccessor();
  const { isCameraOn, isMicOn, newVideoStream, newAudioStream, isRecord, isScreenSharing, usePortrait: isPortrait } = getControls();

  const [micDevices, setMicDevices] = useState<MediaDeviceInfo[]>([]);
  const [selectedMic, setSelectedMic] = useState<string>('');
  const [firstTime, setFirstTime] = useState(true);
  const { getUserData } = useAppAccessor();
  const { language } = getUserData();

  useEffect(() => {
    const getCameraDevices = async () => {
      const devices = await AgoraRTC.getCameras();
      setCameraDevices(devices);
      if (devices.length > 0) {
        // setSelectedCamera(devices[0].deviceId);
      }
    };

    const getMicDevices = async () => {
      const devices = await AgoraRTC.getMicrophones();
      setMicDevices(devices);
      if (devices.length > 0) {
        // setSelectedMic(devices[0].deviceId);
      }
    };

    getCameraDevices();
    getMicDevices();
  }, []);

  useEffect(() => {
    // if (firstTime) {
      if (!isScreenSharing && newVideoStream) {
        handleCameraChange(newVideoStream);
        setFirstTime(false);
      }
    // } else {
    //   setTimeout(() => {
    //     if (!isScreenSharing && newVideoStream) {
    //       handleCameraChange(newVideoStream);
    //     }},1000);
    // }
  },[newVideoStream]);

  useEffect(() => {
    if (newAudioStream) {
      handleMicChange(newAudioStream);
    }
  },[newAudioStream]);

  const handleMicChange = async (deviceId: string) => {
    setSelectedMic(deviceId);
    const stream = await navigator.mediaDevices.getUserMedia({ audio: { deviceId } });
    const audioTrack = stream.getAudioTracks()[0];
    getMediaDevices(stream);
    if (audioTrack) {
      // dispatch(changeAudio(deviceId));
    }
  }

  const handleCameraChange = async (deviceId: string) => {
    setSelectedCamera(deviceId);
    const stream = await navigator.mediaDevices.getUserMedia({ video: { deviceId } });
    const videoTrack = stream.getVideoTracks()[0];
    if (videoTrack) {
      dispatch(changeVideo(deviceId));
    }
 
    if (videoRef.current) {
      videoRef.current.srcObject = stream;
    }
  };

  const getMediaDevices = async (newAudioStream : any) => {
    try {
      var stream;
      if (newAudioStream) {
        stream = newAudioStream;
      } else {
        stream = await navigator.mediaDevices.getUserMedia({ video: true, audio: true });
      }
      
      // if (videoRef.current) {
      //   videoRef.current.srcObject = stream;
      // }

      audioContextRef.current = new (window.AudioContext)();
      analyserRef.current = audioContextRef.current.createAnalyser();
      microphoneRef.current = audioContextRef.current.createMediaStreamSource(stream);

      microphoneRef.current.connect(analyserRef.current);
      analyserRef.current.fftSize = 256;

      const bufferLength = analyserRef.current.frequencyBinCount;
      const dataArray = new Uint8Array(bufferLength);

      const updateAudioLevel = () => {
        analyserRef.current.getByteFrequencyData(dataArray);
        let values = 0;

        for (let i = 0; i < bufferLength; i++) {
          values += dataArray[i];
        }

        const average = values / bufferLength;
        setAudioLevel(average);

        requestAnimationFrame(updateAudioLevel);
      };

      updateAudioLevel();
    } catch (err) {
      console.error('Error accessing media devices.', err);
    }
  };

  const handlePortraitToggle = (checked: boolean) => {
    dispatch(setPortraitMode(checked));
  };

  useEffect(() => {
  
    // getMediaDevices(null);

    return () => {
      if (audioContextRef.current) {
        audioContextRef.current.close();
      }
    };
  }, []);

  return (
    <div className='detectContainer'>
      <div>
        <h3>{language['select_microphone']}</h3>
        <select
          disabled={!isMicOn}
          value={selectedMic}
          onChange={(e) => handleMicChange(e.target.value)}
          className="text-white bg-[#202121] border border-gray-700 rounded"
        >
          <option value="" disabled>
            {language['microphone_prompt']}
          </option>
          {micDevices.map((device) => (
            <option key={device.deviceId} value={device.deviceId}>
              {device.label || `Microphone ${device.deviceId}`}
            </option>
          ))}
        </select>
        <p>{language['input_level']}:</p>
        <div style={{ border: '1px solid black', width: '300px', height: '20px', marginBottom: '20px', marginLeft:'20%'}}>
          <div style={{ background: 'blue', width: `${audioLevel}%`, height: '100%' }}></div>
        </div>
      </div>

      {!isRecord && <div>
        <h3>{language['use_portrait']}</h3>
        <div className="flex items-center gap-2">
        <span className="text-sm font-medium text-gray-900 dark:text-gray-300">
          {language['use_portrait']}
          </span>
          <label className="relative inline-flex items-center cursor-pointer">
            <input
              type="checkbox"
              className="sr-only peer"
              checked={isPortrait}
              disabled={!isCameraOn}
              onChange={(e) => handlePortraitToggle(e.target.checked)}
            />
            <div className="w-11 h-6 bg-gray-200 peer-focus:outline-none peer-focus:ring-4 peer-focus:ring-blue-300 dark:peer-focus:ring-blue-800 rounded-full peer dark:bg-gray-700 peer-checked:after:translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:left-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all dark:border-gray-600 peer-checked:bg-blue-600"></div>
          </label>
          <span className="text-sm font-medium text-gray-900 dark:text-gray-300">
            {language['use_portrait']}
          </span>
        </div>
      </div>}

      <div>
        <h3>{language['select_camera']}</h3>       
        <select
        disabled={!isCameraOn}
        value={selectedCamera}
        onChange={(e) => handleCameraChange(e.target.value)}
        className="text-white bg-[#202121] border border-gray-700 rounded"
      >
        <option value="" disabled>
        {language['camera_prompt']}
        </option>
        {cameraDevices.map((device) => (
          <option key={device.deviceId} value={device.deviceId}>
            {device.label || `Camera ${device.deviceId}`}
          </option>
        ))}
      </select>
        <p>{language['preview_label']}</p>
        <video ref={videoRef} autoPlay playsInline style={{ width: '300px', height: '200px', marginLeft:'20%' }} />
      </div>
    </div>
  );
};

export default MediaDeviceTest;